import React, { Component } from "react";
import cn from "classnames";
import Layout from "./Layout";
import "./AbsoluteLayout.less";
import FillLayout from "./fill/FillLayout";

const CLASS_NAME = "fct-absolute-layout";

class AbsoluteLayout extends Component {
  render() {
    const { children, className, ...props } = this.props;
    return (
      <Layout className={cn(CLASS_NAME, className)} {...props}>
        {children}
      </Layout>
    );
  }
}

AbsoluteLayout.Item = FillLayout;
export default AbsoluteLayout;



// WEBPACK FOOTER //
// ./layout/AbsoluteLayout.js